import {JsonService, UtilService} from "@maidi/common";
import Vue from "vue";

export const ProcessType = {
  'Start': "start",
  'Section': "section",
  'Condition': "condition",
  'Approve': "approve",
  'Notify': "notify"
}

export const CompareType = {
  'Less': "less",
  'Greater': "greater",
  'Equal': "equal",
  'LessEqual': "less_equal",
  'GreaterEqual': "greater_equal",
  'Between': "between"
}

export const ApproveType = {
  'Range': "range",    //指定范围
  'Select': "select",  //自选
  'Originator': "originator",//发起人
  'FormContacts': "form_contacts",//表单联系人
  'Director': "director",//申请人的主管
  'RangeAndSelect': "range_and_select"//指定和自选
}

export const ActivateType = {
  'Successively': "one_by_one",//依次
  'AllAnd': "and",//会签
  'AllOr': "or",//或签
  'Notify': "notify"//通知，不在该节点等待
}

export const SelectRange = {
  'Org': "org",            //随意选择
  'Contacts': "contacts",  //联系人
  'Range': "range"         //指定范围
}


function RecursionFindNext(set, start) {
  const list = start ? [start] : [];
  let index, node = start;
  while ((index = set.findIndex(item => item.prev === (node && node.id))) >= 0) {
    node = set.splice(index, 1)[0];
    list.push(node);
  }
  return list;
}

function TreeToList(nodes) {
  const list = JsonService.clone(nodes);
  list.forEach(item => {
    if (!item.prev) {
      delete item.prev;
    }
    if (!item.section) {
      delete item.section;
    }
    if (item.type !== ProcessType.Section) {
      return;
    }
    item.content.forEach(items => {
      list.push(...TreeToList(items));
    });
    delete item.content;
  });
  return list;
}

export class ProcessModel {

  static $content = [];
  static $tree = [];
  static $dict = {};
  static $whereList = [];//分支条件

  static getTree() {
    return this.$tree;
  }

  static getDict() {
    return this.$dict;
  }

  static getList() {
    return TreeToList(this.$tree).filter(item => item.id);
  }

  static getContent() {
    const list = JsonService.clone(this.getList());
    list.forEach((item) => item.type === ProcessType.Section && (delete item.content));
    return list;
  }

  static referenced() {
    return Object.entries(this.$dict).map(([key, field]) => field).reduce((list, field) => {
      if (field.type === "condition" && field.content && field.content.length) {
        list.push(...field.content);
      } else if (field.type === "approve" && field.content.type === "form_contacts") {
        field.content.form_contacts && field.content.form_contacts.key && list.push(field.content.form_contacts);
      }
      return list;
    }, []);
  }

  static referencedKey() {
    const referenced = this.referenced();
    return referenced.map((field) => field.key);
  }

  static init(content = []) {
    this.$content.length = 0;
    this.$tree.length = 0;
    this.$dict = {};
    this.$content.push(...content);
    this.translate();
  }

  static translate() {
    this.$dict = {};
    const tree = this.$content.map(node => {
      this.$dict[node.id] = this.$dict[node.id] || {};
      Object.assign(this.$dict[node.id], node);
      if (node.section) {
        this.$dict[node.section] = this.$dict[node.section] || {};
        this.$dict[node.section].$items = this.$dict[node.section].$items || [];
        this.$dict[node.section].$items.push(this.$dict[node.id]);
      }
      return this.$dict[node.id];
    });
    tree.forEach((node) => {
      if (node.type !== ProcessType.Section || !node.$items) {
        return;
      }
      const $items = node.$items;
      delete node.$items;
      node.content = $items.filter((node) => !node.prev).sort((item1, item2) => {
        return (item1.order || 0) < (item2.order || 0) ? -1 : 1;
      }).map((item, index) => {
        return RecursionFindNext($items, item);
      });
      this.refreshOrder(node);
    });
    this.$tree.length = 0;
    this.$tree.push(...RecursionFindNext(tree, tree.find(node => !node.prev && !node.section)));
  }

  static ownerList(node) {
    return node && node.section && this.$dict[node.section] ? this.$dict[node.section].content.find((content) => content.some(item => item.id === node.id)) : this.$tree;
  }

  static remove(node) {
    node && delete this.$dict[node.id];
    const list = this.ownerList(node);
    const index = list.findIndex(item => item.id === node.id);
    if (index === -1) {
      return;
    }
    if (node.type !== ProcessType.Condition) {
      const next = list[index + 1];
      let prev = node.prev;
      if (node.type === ProcessType.Section && node.content && node.content.length === 1 && node.content[0].length > 1) {
        const content = node.content[0];
        delete this.$dict[content[0].id];
        content.splice(0, 1);
        content[0].prev = prev;
        prev = content[content.length - 1].id;
        content.forEach(item => item.section = node.section);
        list.splice(index, 1, ...content);
      } else {
        list.splice(index, 1);
      }
      if (next) {
        next.prev = prev;
      }
      return;
    }
    if (!node.section) {
      return;
    }
    list.splice(index);
    if (index > 0) {
      return;
    }
    this.$dict[node.section].content = this.$dict[node.section].content.filter((content) => content.length > 0);
    this.refreshOrder(this.$dict[node.section]);
    if (this.$dict[node.section].content.length > 1) {
      return;
    }
    // else if (this.$dict[node.section].content.length === 1) {
    //   this.$dict[node.section].content[0].forEach((item: any) => this.remove(this.$dict[item.id]));
    // }
    this.remove(this.$dict[node.section]);
  }

  static create(type) {
    let id = UtilService.random(6);

    const node = {
      id,
      name: {"notify": "抄送", "approve": "审批"}[type] || "",
      type
    };
    if (type === ProcessType.Approve) {
      node.content = {
        type: ApproveType.Select,
        multi: false
      };
    } else if (type === ProcessType.Notify) {
      node.content = {
        type: null,
        multi: null
      };
    }
    this.$dict[id] = node;
    return node;
  }

  static add(prev, type) {
    let node = this.create(type);
    const prevNode = this.$dict[prev];
    const list = this.ownerList(prevNode);
    const index = list.findIndex(item => item.id === prev);
    if (index === -1 && prev) {
      return;
    }
    const next = list[index + 1];
    if (next) {
      next.prev = node.id;
    }
    if (type === ProcessType.Condition) {
      const content = list.splice(index + 1);
      node.name = "";
      node.content = [];
      content.unshift(node);
      node = this.create(ProcessType.Section);
      content.forEach(item => item.section = node.id);
      const condition2 = this.create(type);
      condition2.name = "";
      condition2.section = node.id;
      Vue.set(node, "content", [content, [condition2]]);
      this.refreshOrder(node);
      list.push(node);
    } else {
      list.splice(index + 1, 0, node);
    }
    prevNode && prevNode.section && (node.section = prevNode.section);
    if (prev) {
      node.prev = prev;
    }
    return node;
  }

  static addCondition(node) {
    const condition = this.create(ProcessType.Condition);
    condition.section = node.id;
    condition.content = [];
    node.content.push([condition]);
    this.refreshOrder(node);
  }

  static set(id, property, value) {
    const node = this.$dict[id];
    if (!node) {
      return;
    }
    Vue.set(node, property, value);
  }

  static setName(id, name) {
    this.set(id, "name", name);
  }

  static setContent(id, content) {
    this.set(id, "content", content);
  }

  static refreshOrder(section) {
    section.content.forEach((item, index) => {
      const condition = item[0];
      condition.order = index + 1;
      condition.name = condition.name || "条件" + condition.order;
      Vue.set(condition, "last", index === section.content.length - 1)
    });
  }

  static sort(id, change = -1) {
    if (change !== -1) {
      change = 1;
    }
    const node = this.$dict[id];
    const section = this.$dict[node.section];
    const index = section.content.findIndex(item => item[0].id === id);
    if (index === -1) {
      return;
    }
    if (index + change === -1 || index + change === section.content.length) {
      return;
    }
    section.content.splice(index + change, 0, ...section.content.splice(index, 1));
    this.refreshOrder(section);
  }

  static setWhereList(whereList) {
    this.$whereList = whereList;
  }

  static getWhereList() {
    return this.$whereList
  }
}
